import { Accordion, Alert, Button, Container } from "react-bootstrap";
import {
  FaQuestionCircle,
  FaShieldAlt,
  FaRobot,
  FaLock,
  FaMoneyCheckAlt,
  FaUsers,
  FaFileExport,
  FaCoffee,
  FaRocket,
  FaEnvelope,
  FaRegClock,
  FaMobileAlt,
  FaPaw,
  FaTrashAlt,
  FaFileUpload,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../components/LanguageSwitcher";
import AppContext from "../context/app-context";
import { useContext } from "react";

const FAQPage = () => {
  const { t } = useTranslation();
  const { theme } = useContext(AppContext);

  const faqItems = [
    {
      key: "gettingStarted",
      icon: <FaRocket className="me-2" />,
      question: t("faq.gettingStarted.question"),
      answer: t("faq.gettingStarted.answer"),
    },
    {
      key: "bulkAdd",
      icon: <FaFileUpload className="me-2" />,
      question: t("faq.bulkAdd.question"),
      answer: t("faq.bulkAdd.answer"),
    },
    {
      key: "aiUsage",
      icon: <FaRobot className="me-2" />,
      question: t("faq.aiUsage.question"),
      answer: t("faq.aiUsage.answer"),
    },
    {
      key: "emailProcessing",
      icon: <FaEnvelope className="me-2" />,
      question: t("faq.emailProcessing.question"),
      answer: t("faq.emailProcessing.answer"),
    },
    {
      key: "freeLimits",
      icon: <FaRegClock className="me-2" />,
      question: t("faq.freeLimits.question"),
      answer: t("faq.freeLimits.answer"),
    },
    {
      key: "pricing",
      icon: <FaMoneyCheckAlt className="me-2" />,
      question: t("faq.pricing.question"),
      answer: t("faq.pricing.answer"),
    },
    {
      key: "dataStorage",
      icon: <FaLock className="me-2" />,
      question: t("faq.dataStorage.question"),
      answer: t("faq.dataStorage.answer"),
    },
    {
      key: "security",
      icon: <FaShieldAlt className="me-2" />,
      question: t("faq.security.question"),
      answer: t("faq.security.answer"),
    },
    {
      key: "mobileUse",
      icon: <FaMobileAlt className="me-2" />,
      question: t("faq.mobileUse.question"),
      answer: t("faq.mobileUse.answer"),
    },
    {
      key: "exportData",
      icon: <FaFileExport className="me-2" />,
      question: t("faq.exportData.question"),
      answer: t("faq.exportData.answer"),
    },
    {
      key: "teamFeatures",
      icon: <FaUsers className="me-2" />,
      question: t("faq.teamFeatures.question"),
      answer: t("faq.teamFeatures.answer"),
    },
    {
      key: "mascotPurpose",
      icon: <FaPaw className="me-2" />,
      question: t("faq.mascotPurpose.question"),
      answer: t("faq.mascotPurpose.answer"),
    },
    {
      key: "dataDeletion",
      icon: <FaTrashAlt className="me-2" />,
      question: t("faq.dataDeletion.question"),
      answer: t("faq.dataDeletion.answer"),
    },
  ];

  return (
    <Container className="my-5">
      <LanguageSwitcher className="mb-3" />

      <h1 className="mb-4">
        <FaQuestionCircle className="text-primary" /> {t("faq.title")}
      </h1>

      <Alert variant="info" className="mb-4">
        {t("faq.intro")}
      </Alert>

      <Accordion alwaysOpen className="mb-4">
        {faqItems.map((item) => (
          <Accordion.Item key={item.key} eventKey={item.key} className={theme === "dark" ? "bg-dark text-light" : ""}>
            <Accordion.Header>
              {item.icon} {item.question}
            </Accordion.Header>
            <Accordion.Body>
              <div dangerouslySetInnerHTML={{ __html: item.answer }} className="faq-answer-content" />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      <div className="text-center mt-5">
        <h4 className="mb-3">
          <FaCoffee className="me-2" /> {t("faq.needMoreHelp")}
        </h4>
        <Button variant="success" href="mailto:support@kokofin.com" className="me-2">
          {t("faq.contactButton")}
        </Button>
        <Button variant="outline-primary" href="/aboutus">
          {t("faq.aboutButton")}
        </Button>
      </div>
    </Container>
  );
};

export default FAQPage;
